import { __rest, __assign } from 'tslib';
import * as React from 'react';
import Video from './Video/Video.esm.js';

var WrappedVideo = function (_a) {
    var videoJsProps = __rest(_a.fields, []);
    return React.createElement(Video, __assign({}, videoJsProps));
};

export { WrappedVideo as default };
//# sourceMappingURL=WrappedVideo.esm.js.map
